export { default } from './stylist-page.view';
